import { IModel, Model } from './model'
import { IUser, User } from './user'
import { IComment } from './comment'

export interface IPost extends IModel {
  title: string | null
  body: string | null
  meta: PostMeta | null
}

export class Post extends Model implements IPost {
  public title: string | null = null
  public body: string | null = null
  public meta: PostMeta | null = null
}

export class PostMeta {
  public creator: IUser = new User()
  public numLikes: number = 0
  public isLiked: boolean = false
  public tags: string[] = []
  public comments: IComment[] = []
  public newTitle: string = ''
  public newBody: string = ''
}

export class PostForm {
  public title: string = ''
  public body: string = ''
  public tag: string = ''
  public tags: string[] = []
}
